import { TireIcon } from './TireIcon';

/**
 * author: Michael Irigoyen
 * id 5F99B55B-0B1C-4FD7-B9F6-DD35A16DBCF1
 * name tire
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tire.svg
 * tags
 * - Automotive 
 * - Agriculture 
 */
export const WheelIcon = TireIcon;
export default WheelIcon